// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b7f61f04","879":"4ef50d85"}[chunkId] + ".chunk.js";
};